module.exports = __webpack_public_path__ + "img/spinach.2828d4a7.jpg";